import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../../common'

$(init)

async function init () {
  let $page = $('#my-package-list-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let package_list = (await get_json(`/premium/get-my-premium-plans`)).data
    $page.find('.loading-indicator').addClass('d-none')
    if (package_list.length == 0) {
      $page.find('.my-packages-empty-empty').removeClass('d-none')
    } else {
      let $plans = $page.find('.my-packages')
      $plans.removeClass('d-none')
      $plans.html('')
      for (let _package of package_list) {
        _package.created_at_text = (new Date(parseInt(_package.created_at) * 1000)).toLocaleString('en-US', {
          weekday: 'short', // long, short, narrow
          day: 'numeric', // numeric, 2-digit
          year: 'numeric', // numeric, 2-digit
          month: 'long', // numeric, 2-digit, long, short, narrow
          hour: 'numeric', // numeric, 2-digit
          minute: 'numeric', // numeric, 2-digit
          second: 'numeric', // numeric, 2-digit
        })
        $plans.append(eval_html_template('#my-package-template', _package))
      }
    }
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
